<template>
    <div
        v-if="selectedListIds.length > 0"
        :class="{
            ['root']: true,
            ['regular-position']: regularPosition,
        }"
        :style="'top: ' + top + 'px; width: ' + width + 'px'"
        style="z-index: 3;"
    >
        <v-simple-checkbox
            v-if="showBulkSelect"
            :value="isSelected"
            indeterminate
            color="white"
            class="ml-1"
            @input="massSelection"
        />
        <span
            v-if="bulkActionErrorsTotal"
            class="white--text body-1 ml-2"
        >
            {{ bulkActionErrorsTotal }}
            {{ isMobile ? itemsText : itemsErrorsText }}
        </span>
        <span
            v-else-if="!isMobile"
            class="white--text body-1 ml-2"
        >
            {{ selectedListIds.length }}
            <!-- CODE REVIEW WITH JAANUS {{ selectedListIds.length / 2 }}-->
            {{ itemsSelectedText }}
        </span>
        <v-spacer />
        <v-row
            justify="end"
            align="center"
            class="mr-2 custom-row"
        >
            <slot name="actions"></slot>
        </v-row>
    </div>
</template>

<script>
import TaskModule from "@/store/modules/task";
import AppModule from "@/store/modules/app";
import { computed, ref, watch } from "@vue/composition-api";
import DelegateMenu from "./BulkActionDelegate.vue";

export default {
    name: "BulkActionBar",
    components: {
        DelegateMenu,
    },
    props: {
        items: {
            type: Array,
            default: null
        },
        isMobile: {
            type: Boolean,
            default: false
        },
        selectedListIds: {
            type: Array,
            default: () => []
        },
        showBulkSelect: {
            type: Boolean,
            default: true
        },
        itemsText: {
            type: String,
            default: ""
        },
        itemsErrorsText: {
            type: String,
            default: ""
        },
        itemsSelectedText: {
            type: String,
            default: ""
        },
        relativeElem: {
            type: Object,
            default: null
        },
        offsetY: {
            type: Number,
            default: 0
        },
        isSticky: {
            type: Boolean,
            default: false
        },
        bulkActionErrorsTotal: {
            type: Number,
            default: 0
        }
    },
    setup(props) {
        const {
            clearAllSelectedListIds,
        } = TaskModule();

        const {
            isCalendarOpen,
        } = AppModule();
        const regularPosition = ref(false);
        const top = ref(0);
        const width = ref(0);

        const isSelected = computed(() => {
            return true;
        });

        const massSelection = () => {
            clearAllSelectedListIds();
        };

        const calculatePosition = () => {
            try {
                if (props.relativeElem && props.relativeElem.$el !== null) {
                    const scrollTop = props.relativeElem.$el.getBoundingClientRect().top;
                    width.value = props.relativeElem.$el.getBoundingClientRect().width;

                    if (props.isSticky) {
                        top.value = props.offsetY
                        regularPosition.value = true;
                    }
                    else if (scrollTop < 125) {
                        regularPosition.value = true;
                        top.value = 114
                    } else {
                        regularPosition.value = false;
                        top.value = props.offsetY
                    }
                }
            } catch (err) {
                console.error("addEventListener scroll taskListDashboard", err);
            }
        }

        window.addEventListener("scroll", calculatePosition);
        window.addEventListener("resize", calculatePosition);

        watch(
            () => [props.selectedListIds, isCalendarOpen.value],
            () => {
                calculatePosition()
            }
        )

        return {
            isSelected,
            massSelection,
            close,
            regularPosition,
            top,
            width
        };
    }
};
</script>

<style lang="scss" scoped>
.root {
    background: var(--v-gradient-base);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.08),
    0px 1px 12px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    height: 56px;
    z-index: 2;
    padding: 10px;
    transform: translateY(-100%);

    &.regular-position {
        position: fixed;
    }
}

.custom-row {
    position: relative;
}
</style>
